export enum FormType {
    Rectangle = 1,
    Circle = 2,
    Polygon = 3
}
